
import { Search } from 'vant'
import { checkBrowser } from '../../../assets/js/xjpublic';
// import {jsSdk} from '../../../assets/libs/loadjs';

export default {
  name: 'home',
  components: {
    [Search.name]: Search
  },
  data () {
    return {
      getBridTiems: 0
    }
  },
  methods: {
    // 先检查WeixinJSBridge是否已经加载出来,否则在加载之前点击确定按钮会出错
    checkWeixinJSBridgeFn () {
      let _this = this;
      if (checkBrowser.isWx()) {
        try {
          if (WeixinJSBridge) {
            this.noImeiNoteFn();
          }
        } catch (err) {
          if (this.getBridTiems < 30) {
            setTimeout(function () {
              _this.getBridTiems++;
              _this.checkWeixinJSBridgeFn();
            }, 300)
          } else {
            this.noImeiNoteFn();
          }
        }
      } else {
        this.noImeiNoteFn();
      }
    },
    noImeiNoteFn () {
      this.$dialog({
        message: '请用微信扫描设备上的二维码绑定设备！'
      }).then(() => {
          console.log(checkBrowser.isWx());
          if (checkBrowser.isWx()) {
            // 方法一
            console.log(WeixinJSBridge);
            WeixinJSBridge.call('closeWindow');
            // 方法二
            // 调用微信SDK
            // jsSdk(this.$store.state.customer, ['closeWindow']).then(function(){
            //   wx.closeWindow();
            // }).catch((e)=>{console.log(e);});
          } else {
            // window.opener = null;
            // window.open('', '_self');
            window.location.href = 'about:blank';
            window.close();
          }
      })
    }
  },
  mounted () {
    // this.noImeiNoteFn();
    this.checkWeixinJSBridgeFn();
  }
}
